import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import GoogleIcon from '../../assets/images/google-icon.svg';
import { useEffect } from 'react';
import { signInWithGoogle } from '../../client/firebase/auth';

const GoogleButton = ({ user, isLoading }) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (user) navigate('/dashboard');
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const handleLogin = async () => {
    try {
      await signInWithGoogle();
      navigate('/dashboard');
    } catch (error) {
      alert(error.message);
    }
  };

  if (isLoading) {
    return (
      <button className="bg-white flex shadow:md animate-pulse rounded-lg px-6 py-2 font-semibold">
        <div className="flex justify-center my-2 px-10" data-testid="google-button-loading">
          <span className="circle animate-loader"></span>
          <span className="circle animate-loader animation-delay-200"></span>
          <span className="circle animate-loader animation-delay-400"></span>
        </div>
      </button>
    );
  }

  return (
    !user && (
      <button
        className="flex items-center shadow:md rounded-md bg-google-blue font-semibold"
        onClick={handleLogin}
      >
        <div className="bg-white rounded-l-md p-2">
          <img className="w-8 p-1" src={GoogleIcon} alt="google" />
        </div>
        <p className="rounded-lg text-white px-4">Sign in with Google</p>
      </button>
    )
  );
};

const mapStateToProps = (state) => ({
  user: state.auth.user,
  isLoading: state.auth.isLoading,
});

export default connect(mapStateToProps, null)(GoogleButton);
